// Propsのデフォルト設定を無効にする
/* eslint-disable react/require-default-props */
import {
  TRANSLATION_LIST_VIEW_TYPE,
  TranslationListViewType,
} from '@/constants';

import styles from './TranslationMessageOverlayView.module.scss';

/**
 * メッセージレイヤー用ClassName
 *
 * @param translationListViewType  画面タイプ（ホストorゲスト）
 * @param isDisplayFooter フッター開閉状況(true=開いている)
 * @returns
 */
const messageLayerClassName = (
  translationListViewType: TranslationListViewType,
  isDisplayFooter: boolean,
) => {
  if (translationListViewType === TRANSLATION_LIST_VIEW_TYPE.TRANSLATION) {
    return isDisplayFooter
      ? styles['message-layer-outer-host-open']
      : styles['message-layer-outer-host-close'];
  }

  return styles['message-layer-outer-guest'];
};

/**
 * プロパティ
 */
export type Props = {
  // 表示するか否か(true=表示|false=非表示)
  isOpen: boolean;
  // メッセージ
  text: string;
  // 画面タイプ（ホストorゲスト）
  translationListViewType: TranslationListViewType;
  // フッター開閉状況(true=開いている/false=閉じている)
  isDisplayFooter?: boolean;
};

/**
 * 翻訳画面用
 * メッセージオーバレイビュー コンポーネント
 */
export const TranslationMessageOverlayView = ({
  isOpen = false,
  text,
  translationListViewType,
  isDisplayFooter = true,
}: Props) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div
      className={messageLayerClassName(
        translationListViewType,
        isDisplayFooter,
      )}
      data-testid="message-overlay-view"
    >
      <div className={styles.message}>
        <span>{text}</span>
      </div>
    </div>
  );
};
